import type { DetailedBooking_autoCancellation } from "../../../../common/graphql/fragments/gql/DetailedBooking";
import type { UpdateSubmitInformation } from "../../../../common/update-information/utils/getUpdateSubmitInformation";

export const AUTO_CANCELLATION_MESSAGE_CODE = "IEXT-009";

export const resolveAutoCancellationInformation = (
  updateSubmitInformation: UpdateSubmitInformation,
  autoCancellation: DetailedBooking_autoCancellation | null,
) =>
  updateSubmitInformation.messages.some(
    (m) => m.code === AUTO_CANCELLATION_MESSAGE_CODE,
  )
    ? null
    : autoCancellation;
